var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"backdrop"},[_c('div',{staticClass:"modal",class:{'modal--l' : _vm.params && _vm.params.grande}},[_c(_vm.component,{tag:"component",attrs:{"params":_vm.params}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }